// extracted by mini-css-extract-plugin
module.exports = {"banner":"style_banner__1Axp2","banner__container":"style_banner__container__16bwV","banner__text":"style_banner__text__lwwe-","banner__buttons":"style_banner__buttons__2jaua"};